export default __webpack_public_path__ + "static/media/mutation-phone2.c5a34b49.png";